import * as React from 'react';

import * as styles from './styles.css';

export interface ICommunicationImageProps {
  src: string;
  alt: string;
  testId?: string;
}

export const CommunicationImage: React.FC<ICommunicationImageProps> = ({
  src,
  alt,
  testId = 'communication-image',
}) => {
  return <img className={styles['image']} src={src} alt={alt} data-testid={testId} />;
};

CommunicationImage.displayName = 'CommunicationImage';
